// components/ProductSelection/utils/productHelpers.js

export const parseSearchQuery = (query) => {
  const productIdRegex = /^[A-Z0-9]{6,}$/i;
  const karigarCodeRegex = /^KAR[0-9]{3,}$/i;
  const huidRegex = /^[0-9]{6}$/;

  const suggestion = {
    type: null,
    value: query,
    fields: {},
  };

  if (productIdRegex.test(query.trim())) {
    suggestion.type = "productId";
    suggestion.fields.productId = query.trim().toUpperCase();
  } else if (karigarCodeRegex.test(query.trim())) {
    suggestion.type = "karigarCode";
    suggestion.fields.karigarCode = query.trim().toUpperCase();
  } else if (huidRegex.test(query.trim())) {
    suggestion.type = "huid";
    suggestion.fields["hallmark.huid"] = query.trim();
  } else if (query.length > 0) {
    suggestion.type = "name";
    suggestion.fields.name = query;
  }

  return suggestion;
};

export const initializeFilters = (selectedBranch, status = "ACTIVE") => {
  return {
    type: "",
    subType: "",
    categories: [],
    minGrossWeight: "",
    maxGrossWeight: "",
    minNetWeight: "",
    maxNetWeight: "",
    purity: "",
    isHallmarked: "",
    isFeatured: "",
    minPrice: "",
    maxPrice: "",
    branchCode: selectedBranch || "",
    status: status,
  };
};

export const calculatePricingSummary = (products) => {
  const totalItems = products.length;
  const totalWeight = products.reduce((sum, p) => sum + (p.netWeight || 0), 0);
  const prices = products
    .map((p) => p.pricing?.summary?.lowestPrice)
    .filter(Boolean);
  const totalPrice = prices.reduce((sum, price) => sum + price, 0);

  return {
    totalItems,
    totalWeight,
    totalPrice,
    averagePrice: prices.length > 0 ? totalPrice / prices.length : 0,
  };
};
